import { sanitizeDecimalInput } from './decimalInput';

/**
 * Returns the rate as typed - `0.75` for 0.75%, not `0.0075`. An empty field also reads as 0 and 0%
 * is a valid APY, so a required-field check has to test the raw string rather than this number.
 */
export const parsePercent = (raw: string): number => {
  const parsed = Number(sanitizeDecimalInput(raw));

  return Number.isNaN(parsed) ? 0 : parsed;
};

/**
 * Pads a rate to two decimals so `1` reads as `1.00`, while keeping the third decimal the field
 * accepts - rounding to a flat two would settle the display on a rate the math did not use.
 */
const PERCENT_FORMATTER = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 3 });

export const formatPercent = (value: number): string => PERCENT_FORMATTER.format(value);
